<template>
  <div>
    <div v-for="(snackBar, key) in snackBars" :key="key" class="box has-background-danger has-text-white is-flex" style="position: fixed; z-index: 50; bottom: 0; width: 100%; border: none; border-radius: 0; align-items: center;" :style="$device.isDesktop ? 'padding: 15px;' : 'padding: 10px;'">
      <div style="width: 100%;">
        <p :class="{'font-12': !$device.isDesktop, 'font-14': $device.isDesktop}">Sepertinya koneksi Anda sedang lambat/bermasalah, <a href="" @click.prevent="reloadPage" class="has-text-white" style="text-decoration: underline;">klik disini</a> untuk muat ulang halaman.</p>
      </div>
      <div class="delete" @click.prevent="remove(key)"></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    snackBars() {
      return this.$store.state.notifications.snack_bars;
    }
  },

  watch: {
    snackBars(values) {
      if (!this.isEmpty(values)) {
        setTimeout(() => {
          this.remove(0);
        }, 5000)
      }
    }
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },
    remove(key) {
      this.$store.commit('notifications/removeSnackBar', key);
    }
  }
}
</script>

<style>

</style>
